import React from 'react';
import { Wrapper } from './wait-approve-step.styles';
import { WaitApproveStepProps } from './types';
import { IconTaskDone } from '../../../../../shared/icon/icon-task-done/icon-task-done';
import { Typography } from '../../../../../shared/ui/typography/typography';
import { RequestEmailBtn } from '../request-email-btn/request-email-btn';
import { useSendVerifyEmailMutation } from '../../api/register-api';

export const WaitApproveStep: React.FC<WaitApproveStepProps> = ({ isShow, email }) => {
    const [sendEmailVerify, sendEmailVerifyResult] = useSendVerifyEmailMutation();

    if (!isShow) {
        return null;
    }

    return (
        <Wrapper>
            <IconTaskDone />
            <Typography size='subtitle1' align='center'>
                На указанный e-mail (<b>{email}</b>) было направлено письмо с ссылкой для подверждения. Перейдите по
                ссылке, чтобы завершить регистрацию.
            </Typography>
            <RequestEmailBtn
                disabled={sendEmailVerifyResult.isLoading}
                preloader={sendEmailVerifyResult.isLoading}
                isSuccessRequestedAgain={sendEmailVerifyResult.isSuccess}
                onClick={() => sendEmailVerify({ email })}
            />
        </Wrapper>
    );
};
